import { ApolloProvider } from '@apollo/client';
import { type ReactNode } from 'react';
import { client } from '../configs/apollo-client';

export interface GraphQLProviderProps {
  children: ReactNode;
}

export function GraphQLProvider({ children }: GraphQLProviderProps) {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
